import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html',
  styleUrls: ['./page-notfound.component.scss']
})
export class PageNotfoundComponent implements OnInit {

  userType: string;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userType = params['user'];
    });
  }

  isCustomer() {
    return this.userType == "customer"
  }

  partner() {
    localStorage.clear();
    window.location.href = '/login'
    // if (localStorage.getItem('is_approved') != null && localStorage.getItem('is_approved') == "true") {
    //   this.router.navigate(['/admin/dashboard']);
    // }
    // else if (localStorage.getItem('has_onboarded') != null && localStorage.getItem('has_onboarded') == "false") {
    //   this.router.navigate(['/onboarding']);
    // }
    // else if (localStorage.getItem('has_onboarded') == null || !localStorage.getItem('has_onboarded')) {
    //   localStorage.clear();
    //   this.router.navigate(['/login'])
    // }
    // else {
    //   this.router.navigate(['/onboarding/submitted']);
    // }
  }

}
